/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateUpdateRoleDto,
    CreateUpdateRoleDtoFromJSON,
    CreateUpdateRoleDtoToJSON,
    ExceptionDto,
    ExceptionDtoFromJSON,
    ExceptionDtoToJSON,
    GetAllRolesQuery,
    GetAllRolesQueryFromJSON,
    GetAllRolesQueryToJSON,
    GetRolePermissionRelationsQuery,
    GetRolePermissionRelationsQueryFromJSON,
    GetRolePermissionRelationsQueryToJSON,
    GetUserPermissionRelationsQuery,
    GetUserPermissionRelationsQueryFromJSON,
    GetUserPermissionRelationsQueryToJSON,
    GetUserRoleRelationsQuery,
    GetUserRoleRelationsQueryFromJSON,
    GetUserRoleRelationsQueryToJSON,
    PermissionVm,
    PermissionVmFromJSON,
    PermissionVmToJSON,
    RoleListVm,
    RoleListVmFromJSON,
    RoleListVmToJSON,
    RoleListVmPaginatedSearchResponse,
    RoleListVmPaginatedSearchResponseFromJSON,
    RoleListVmPaginatedSearchResponseToJSON,
    RolePermissionRelationsVm,
    RolePermissionRelationsVmFromJSON,
    RolePermissionRelationsVmToJSON,
    SimpleUserVm,
    SimpleUserVmFromJSON,
    SimpleUserVmToJSON,
    UpdateRolePermissionRelationsCommand,
    UpdateRolePermissionRelationsCommandFromJSON,
    UpdateRolePermissionRelationsCommandToJSON,
    UpdateUserPermissionRelationsCommand,
    UpdateUserPermissionRelationsCommandFromJSON,
    UpdateUserPermissionRelationsCommandToJSON,
    UpdateUserRoleRelationsCommand,
    UpdateUserRoleRelationsCommandFromJSON,
    UpdateUserRoleRelationsCommandToJSON,
    UserPermissionRelationsVm,
    UserPermissionRelationsVmFromJSON,
    UserPermissionRelationsVmToJSON,
    UserRoleRelationsVm,
    UserRoleRelationsVmFromJSON,
    UserRoleRelationsVmToJSON,
} from '../models';

export interface ApiRolePermissionsGetAllRolesPostRequest {
    getAllRolesQuery?: GetAllRolesQuery;
}

export interface ApiRolePermissionsGetRolePermissionRelationsPostRequest {
    getRolePermissionRelationsQuery?: GetRolePermissionRelationsQuery;
}

export interface ApiRolePermissionsGetUserPermissionRelationsPostRequest {
    getUserPermissionRelationsQuery?: GetUserPermissionRelationsQuery;
}

export interface ApiRolePermissionsGetUserRoleRelationsPostRequest {
    getUserRoleRelationsQuery?: GetUserRoleRelationsQuery;
}

export interface ApiRolePermissionsIdDeleteRequest {
    id: string;
}

export interface ApiRolePermissionsIdGetRequest {
    id: string;
}

export interface ApiRolePermissionsIdPutRequest {
    id: string;
    createUpdateRoleDto?: CreateUpdateRoleDto;
}

export interface ApiRolePermissionsPostRequest {
    createUpdateRoleDto?: CreateUpdateRoleDto;
}

export interface ApiRolePermissionsUpdateRolePermissionRelationsPutRequest {
    updateRolePermissionRelationsCommand?: UpdateRolePermissionRelationsCommand;
}

export interface ApiRolePermissionsUpdateUserPermissionRelationsPutRequest {
    updateUserPermissionRelationsCommand?: UpdateUserPermissionRelationsCommand;
}

export interface ApiRolePermissionsUpdateUserRoleRelationsPutRequest {
    updateUserRoleRelationsCommand?: UpdateUserRoleRelationsCommand;
}

/**
 * 
 */
export class RolePermissionsApi extends runtime.BaseAPI {

    /**
     * Get all permissions
     */
    async apiRolePermissionsGetAllPermissionsGetRaw(): Promise<runtime.ApiResponse<Array<PermissionVm>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/GetAllPermissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PermissionVmFromJSON));
    }

    /**
     * Get all permissions
     */
    async apiRolePermissionsGetAllPermissionsGet(): Promise<Array<PermissionVm>> {
        const response = await this.apiRolePermissionsGetAllPermissionsGetRaw();
        return await response.value();
    }

    /**
     * Get all roles.
     */
    async apiRolePermissionsGetAllRolesPostRaw(requestParameters: ApiRolePermissionsGetAllRolesPostRequest): Promise<runtime.ApiResponse<RoleListVmPaginatedSearchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/GetAllRoles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAllRolesQueryToJSON(requestParameters.getAllRolesQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleListVmPaginatedSearchResponseFromJSON(jsonValue));
    }

    /**
     * Get all roles.
     */
    async apiRolePermissionsGetAllRolesPost(requestParameters: ApiRolePermissionsGetAllRolesPostRequest): Promise<RoleListVmPaginatedSearchResponse> {
        const response = await this.apiRolePermissionsGetAllRolesPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get role permission relations.
     */
    async apiRolePermissionsGetRolePermissionRelationsPostRaw(requestParameters: ApiRolePermissionsGetRolePermissionRelationsPostRequest): Promise<runtime.ApiResponse<RolePermissionRelationsVm>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/GetRolePermissionRelations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetRolePermissionRelationsQueryToJSON(requestParameters.getRolePermissionRelationsQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RolePermissionRelationsVmFromJSON(jsonValue));
    }

    /**
     * Get role permission relations.
     */
    async apiRolePermissionsGetRolePermissionRelationsPost(requestParameters: ApiRolePermissionsGetRolePermissionRelationsPostRequest): Promise<RolePermissionRelationsVm> {
        const response = await this.apiRolePermissionsGetRolePermissionRelationsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get user permission relations.
     */
    async apiRolePermissionsGetUserPermissionRelationsPostRaw(requestParameters: ApiRolePermissionsGetUserPermissionRelationsPostRequest): Promise<runtime.ApiResponse<UserPermissionRelationsVm>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/GetUserPermissionRelations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUserPermissionRelationsQueryToJSON(requestParameters.getUserPermissionRelationsQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionRelationsVmFromJSON(jsonValue));
    }

    /**
     * Get user permission relations.
     */
    async apiRolePermissionsGetUserPermissionRelationsPost(requestParameters: ApiRolePermissionsGetUserPermissionRelationsPostRequest): Promise<UserPermissionRelationsVm> {
        const response = await this.apiRolePermissionsGetUserPermissionRelationsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get user role relations.
     */
    async apiRolePermissionsGetUserRoleRelationsPostRaw(requestParameters: ApiRolePermissionsGetUserRoleRelationsPostRequest): Promise<runtime.ApiResponse<UserRoleRelationsVm>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/GetUserRoleRelations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUserRoleRelationsQueryToJSON(requestParameters.getUserRoleRelationsQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRoleRelationsVmFromJSON(jsonValue));
    }

    /**
     * Get user role relations.
     */
    async apiRolePermissionsGetUserRoleRelationsPost(requestParameters: ApiRolePermissionsGetUserRoleRelationsPostRequest): Promise<UserRoleRelationsVm> {
        const response = await this.apiRolePermissionsGetUserRoleRelationsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get all users.
     */
    async apiRolePermissionsGetUsersGetRaw(): Promise<runtime.ApiResponse<Array<SimpleUserVm>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/GetUsers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SimpleUserVmFromJSON));
    }

    /**
     * Get all users.
     */
    async apiRolePermissionsGetUsersGet(): Promise<Array<SimpleUserVm>> {
        const response = await this.apiRolePermissionsGetUsersGetRaw();
        return await response.value();
    }

    /**
     * Delete role.
     */
    async apiRolePermissionsIdDeleteRaw(requestParameters: ApiRolePermissionsIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiRolePermissionsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete role.
     */
    async apiRolePermissionsIdDelete(requestParameters: ApiRolePermissionsIdDeleteRequest): Promise<void> {
        await this.apiRolePermissionsIdDeleteRaw(requestParameters);
    }

    /**
     * Get detailed role.
     */
    async apiRolePermissionsIdGetRaw(requestParameters: ApiRolePermissionsIdGetRequest): Promise<runtime.ApiResponse<RoleListVm>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiRolePermissionsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleListVmFromJSON(jsonValue));
    }

    /**
     * Get detailed role.
     */
    async apiRolePermissionsIdGet(requestParameters: ApiRolePermissionsIdGetRequest): Promise<RoleListVm> {
        const response = await this.apiRolePermissionsIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update role.
     */
    async apiRolePermissionsIdPutRaw(requestParameters: ApiRolePermissionsIdPutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiRolePermissionsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateRoleDtoToJSON(requestParameters.createUpdateRoleDto),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update role.
     */
    async apiRolePermissionsIdPut(requestParameters: ApiRolePermissionsIdPutRequest): Promise<void> {
        await this.apiRolePermissionsIdPutRaw(requestParameters);
    }

    /**
     * Create role.
     */
    async apiRolePermissionsPostRaw(requestParameters: ApiRolePermissionsPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateRoleDtoToJSON(requestParameters.createUpdateRoleDto),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create role.
     */
    async apiRolePermissionsPost(requestParameters: ApiRolePermissionsPostRequest): Promise<string> {
        const response = await this.apiRolePermissionsPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reset the permissions to the default.
     */
    async apiRolePermissionsResetPermissionsGetRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/ResetPermissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reset the permissions to the default.
     */
    async apiRolePermissionsResetPermissionsGet(): Promise<void> {
        await this.apiRolePermissionsResetPermissionsGetRaw();
    }

    /**
     * Edit role permissions.
     */
    async apiRolePermissionsUpdateRolePermissionRelationsPutRaw(requestParameters: ApiRolePermissionsUpdateRolePermissionRelationsPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/UpdateRolePermissionRelations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRolePermissionRelationsCommandToJSON(requestParameters.updateRolePermissionRelationsCommand),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Edit role permissions.
     */
    async apiRolePermissionsUpdateRolePermissionRelationsPut(requestParameters: ApiRolePermissionsUpdateRolePermissionRelationsPutRequest): Promise<void> {
        await this.apiRolePermissionsUpdateRolePermissionRelationsPutRaw(requestParameters);
    }

    /**
     * Update user roles.
     */
    async apiRolePermissionsUpdateUserPermissionRelationsPutRaw(requestParameters: ApiRolePermissionsUpdateUserPermissionRelationsPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/UpdateUserPermissionRelations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserPermissionRelationsCommandToJSON(requestParameters.updateUserPermissionRelationsCommand),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user roles.
     */
    async apiRolePermissionsUpdateUserPermissionRelationsPut(requestParameters: ApiRolePermissionsUpdateUserPermissionRelationsPutRequest): Promise<void> {
        await this.apiRolePermissionsUpdateUserPermissionRelationsPutRaw(requestParameters);
    }

    /**
     * Update user roles.
     */
    async apiRolePermissionsUpdateUserRoleRelationsPutRaw(requestParameters: ApiRolePermissionsUpdateUserRoleRelationsPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/RolePermissions/UpdateUserRoleRelations`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRoleRelationsCommandToJSON(requestParameters.updateUserRoleRelationsCommand),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user roles.
     */
    async apiRolePermissionsUpdateUserRoleRelationsPut(requestParameters: ApiRolePermissionsUpdateUserRoleRelationsPutRequest): Promise<void> {
        await this.apiRolePermissionsUpdateUserRoleRelationsPutRaw(requestParameters);
    }

}
